import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/Gateway/Gateway.requests'

export default function useGetGateway(id: number) {
    return useRequest({
        key: RequestKeys.getGateway,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.get),
        enabled: Boolean(id),
    })
}
